module.exports = __webpack_public_path__ + "img/Rooms_text03b_predZfalse.6c9617d3.png";